export interface ViewUser
{
  id: string,
  firstName: string,
  lastName: string,
  displayName: string,
  isParticipant: boolean,
  email: string,
  province: string,
  branch: string,
  isBranchVisible: boolean,
  organization: string,
  isOrganizationVisible: boolean,
  accountCreationDate: string,
  lastActiveDate: string,
  isEditEnabled: boolean,
  isDeleteEnabled: boolean,
  roles: any[],
  participantSpecialPermissions: any[],
  isSpecialPermissionVisible: boolean,
  participantRecommendedCourses: any[]
  isRecomendedCoursesVisible: boolean,
  status: string,
  participantPrograms: any[]
}

export function ViewUserDefaultValues(): ViewUser {
  return {
    id: '',
    firstName: '',
    lastName: '',
    displayName:'',
    isParticipant:false,
    email: '',
    province: '',
    branch: '',
    isBranchVisible: false,
    organization: '',
    isOrganizationVisible: false,
    accountCreationDate: '',
    lastActiveDate: '',
    isEditEnabled: false,
    isDeleteEnabled: false,
    roles: [],
    participantSpecialPermissions: [],
    isSpecialPermissionVisible: false,
    participantRecommendedCourses: [],
    isRecomendedCoursesVisible: false,
    status:'',
    participantPrograms:[]
  };
}
